/** Shift a calendar anchor by `delta` units of the given view. Shared by the
 *  CalendarHeader prev/next buttons and the j/k keyboard shortcuts so they
 *  always step by the same amount. */
export function shiftAnchor(
  anchor: Date,
  unit: "month" | "week" | "days" | "day",
  delta: number,
  dayCount = 1,
): Date {
  const d = new Date(anchor);
  if (unit === "month") d.setMonth(d.getMonth() + delta);
  else if (unit === "week") d.setDate(d.getDate() + delta * 7);
  else if (unit === "days") d.setDate(d.getDate() + delta * dayCount);
  else d.setDate(d.getDate() + delta);
  return d;
}
